import { render, staticRenderFns } from "./table-released.vue?vue&type=template&id=5a2597f8&scoped=true&"
import script from "./table-released.vue?vue&type=script&lang=js&"
export * from "./table-released.vue?vue&type=script&lang=js&"
import style0 from "./table-released.vue?vue&type=style&index=0&id=5a2597f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2597f8",
  null
  
)

export default component.exports